require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./method-ct-method-taas.json") })
        }
      }, "path---method-ct-method-taas");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---method-ct-method-taas!./.cache/json/method-ct-method-taas.json
// module id = 888
// module chunks = 231608221292675